import $ from 'jquery'

const TRIGGER_SELECTOR = '.accordion-item__toggle'
const TRIGGER_TEXT_SELECTOR = '.accordion-item__toggle-text'
const CONTENT_SELECTOR = '.accordion-item__content'
const ACTIVE_CLASS = 'accordion-item--open'

class Accordions {
  constructor(selector = '.accordion-item') {
    this.items = $(selector)

    this.init()
  }

  init() {
    this.items.each((index, item) => new Accordion(item))
  }
}

class Accordion {
  constructor(item) {
    this.item = $(item)
    this.trigger = $(TRIGGER_SELECTOR, item)
    this.text = $(TRIGGER_TEXT_SELECTOR, item)
    this.content = $(CONTENT_SELECTOR, item)
    console.log(this.text)
    this.translation = {
      less: this.text.data('less'),
      more: this.text.data('more'),
    }

    this.isActive = false

    this.listen()
  }

  listen() {
    this.trigger.on('click', () => {
      event.preventDefault()
      this.isActive ? this.deactivate() : this.activate()
    })
  }

  activate() {
    this.content.slideDown('fast')
    this.item.addClass(ACTIVE_CLASS)
    this.text.html(this.translation.less)
    this.isActive = !this.isActive
  }

  deactivate() {
    this.item.removeClass(ACTIVE_CLASS)
    this.content.slideUp('fast')
    this.text.html(this.translation.more)
    this.isActive = !this.isActive
  }
}

export default Accordions
